import React, { useState } from 'react';
import { Nav, Dropdown } from 'react-bootstrap';
import { LoaderIcon } from '../../Icons';
import Conversations from '../../../../Models/Conversations';

interface ConversationItemProps {
  conversation: Conversations & { unreadMessagesCount?: number };
  timeAgo: (date: string) => string;
  onClose: (id: string) => Promise<void>;
  onDelete: (id: string) => Promise<void>;
}

export const ConversationItem: React.FC<ConversationItemProps> = ({ 
  conversation, 
  timeAgo,
  onClose,
  onDelete
}) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleClose = async () => {
    setIsLoading(true);
    await onClose(conversation.id);
    setIsLoading(false);
  };

  const handleDelete = async () => {
    setIsLoading(true);
    await onDelete(conversation.id);
    setIsLoading(false);
  };

  return (
    <Nav.Link eventKey={conversation.id} className='p-3' disabled={isLoading}>
      <div className="d-flex justify-content-between align-items-center">
        <h4 className="m-0">
          {isLoading && <LoaderIcon width={16} className="me-2" />}
          {conversation.title}
        </h4>
        <div className="d-flex flex-column align-items-center">
          <Dropdown align="end">
            <Dropdown.Toggle as="span" className="btn p-0 border-0 bg-transparent" style={{ cursor: 'pointer' }} />
            <Dropdown.Menu className='shadow'>
              <Dropdown.Item className='py-3' onClick={handleClose} disabled={isLoading}>
                Close
              </Dropdown.Item>
              <Dropdown.Item className='py-3 text-danger' onClick={handleDelete} disabled={isLoading}>
                Delete
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
         
        </div>
      </div>
      <p className="small mb-0" style={{ opacity: 0.6 }}>
        <span>{conversation.jiraIssueKey?.slice(6)}</span>
        <span className="mx-1">•</span>
        <span>{timeAgo(conversation.createdAT)} </span>
         {typeof conversation.unreadMessagesCount === 'number' && conversation.unreadMessagesCount > 0 && (
            <span
              className="mt-1 d-inline-flex justify-content-center align-items-center"
              style={{
                background: '#ffc107',
                color: '#212529',
                borderRadius: '50%',
                width: 22,
                height: 22,
                fontSize: 13,
                fontWeight: 600,
                boxShadow: '0 1px 2px rgba(0,0,0,0.08)',
              }}
            >
              {conversation.unreadMessagesCount}
            </span>
          )}
      </p>
    </Nav.Link>
  );
};


